import React, { useContext } from 'react'
import { useTypedTranslation } from 'app/modules/shared/hooks/use-translation'
import { MainNotificationContext } from 'app/modules/shared'
import Button from 'app/modules/shared/components/button'

declare global {
  interface Window {
    Supademo?: {
      open: (id: string) => void
    }
  }
}

type SupademoTourProps = {
  id: string
  name: string
}

const SupademoTour = ({ id, name }: SupademoTourProps) => {
  const { _t } = useTypedTranslation()
  const mainNotification = useContext(MainNotificationContext)

  const handleOpenSupademoTour = (id: string) => {
    if (window.Supademo) {
      window.Supademo.open(id)
    } else {
      mainNotification.setMessageData(_t('supademo-not-loaded-warning'), 'danger', 5000)
    }
  }

  return (
    <Button
      id={`supademo-tour-${name}`}
      variant="tertiary"
      className="dropdown-item d-flex align-items-center gap-x-2"
      onClick={() => handleOpenSupademoTour(id)}
    >
      <i className="ds3-icon ds3-play" />
      {name}
    </Button>
  )
}

export default SupademoTour
